import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Text } from '@chakra-ui/react';
import { Error, Info } from '../../assets/icons';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function InfoMessage(_ref) {
  var infoMessage = _ref.infoMessage,
    otherStyles = _ref.otherStyles,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? '' : _ref$variant,
    messageId = _ref.messageId;
  var setIconVariant = variant => {
    if (variant === 'Info') {
      return _jsx(Info, {});
    } else {
      return _jsx(Error, {});
    }
  };
  var isInfoVariant = variant === 'Info';
  var liveRegionRole = isInfoVariant ? 'status' : 'alert';
  return _jsxs(Flex, _objectSpread(_objectSpread(_objectSpread({
    id: messageId,
    role: liveRegionRole
  }, !isInfoVariant && {
    'aria-live': 'polite'
  }), {}, {
    direction: "row",
    alignItems: "center",
    position: {
      base: 'relative',
      sm: 'absolute'
    }
  }, _objectSpread(_objectSpread({}, baseStyles), otherStyles)), {}, {
    children: [_jsx(Icon, _objectSpread({
      svg: setIconVariant(variant)
    }, iconStyles)), _jsx(Text, {
      ml: "sm",
      mb: 0,
      children: infoMessage
    })]
  }));
}
var baseStyles = {
  bgColor: 'tooltipError',
  pl: 'sm',
  marginTop: 'md',
  fontSize: 'sm',
  lineHeight: '2',
  fontWeight: 'normal',
  borderRadius: '3',
  overflow: 'none',
  zIndex: '999',
  _before: {
    content: '" "',
    position: 'absolute',
    top: '-0.15rem',
    left: 'xs',
    width: '1.5rem',
    height: '0.75rem',
    zIndex: '-1',
    transform: 'rotate(-45deg)',
    bgColor: 'tooltipError',
    borderRadius: '3'
  }
};
var iconStyles = {
  mt: '-0.15rem',
  ml: 'xs'
};